<template>
    <div class="user-item">
        <span class="w-1/5 flex items-center">
            <avatar :member="user" />
            <span class="ml-2">{{ user.name }}</span>
        </span>
        <span class="w-1/5">{{ user.email }}</span>
        <span class="w-1/5">{{ user.type.name }}</span>
        <span class="w-1/12">
            <span class="dot" :class="{'active': user.active}"></span>
        </span>
        <span class="w-1/5">
            {{ createdAt }}
        </span>
        <span class="ml-auto mr-4">
            
            <md-button :to="{'name': 'users.detail', params: {userId: user.id}}" class="md-dense md-icon-button md-primary">
                <md-icon>edit</md-icon>
            </md-button>
        </span>
    </div>
</template>

<script>
    import Avatar from "../../components/Avatar";
    import {mapState} from "vuex";
    export default {
        name: "UserItem",
        components: {Avatar},
        props: {
            user: {
                type: Object,
                required: true
            }
        },
        computed: {
            ...mapState({
               account: state => state.account.user
            }),
            createdAt() {
                return moment.unix(this.user.created_at).format("DD.MM.YYYY [o] HH:mm")
            }
        }
    }
</script>

<style lang="scss">
    .user-list {
        .user-item {
            @apply bg-white my-3 py-2 px-4 rounded-full flex items-center text-gray-700 shadow;
            
            .dot {
                @apply bg-gray-300 w-3 h-3 rounded-full block;
                &.active {
                    @apply bg-green-400;
                }
            }
        }
    }
</style>